module.exports = {"Notices":"اطلاع رسانی"}